import React, { ReactElement } from 'react'
import { useSelector } from 'react-redux'
import UploadPreview from '../UploadPreview'
import UploadButton from '../UploadButton'
import UploadErrorAlert from '../UploadErrorAlert'
import { ALERT_MESSAGES, FILE_STATUS, STATUS } from '../../../enums/common'
import { IUploadWithRetryFile } from '../../../interfaces/Upload'
import { IStore } from '../../../interfaces/Store'
import DocumentTooltipBuilder from '../DocumentTooltipBuilder'

function UploadFile({
  title,
  updateFiles,
  file,
  index,
  updateFileErrors,
  fileAlert,
  fileStatus,
  status,
  tooltip,
  isMultifile,
  canRetry,
}: IUploadWithRetryFile): ReactElement {
  const removeFile = () => {
    updateFiles(null, index)
    updateFileErrors(ALERT_MESSAGES.mandatory, index)
  }
  const displayTooltip =
    tooltip && fileStatus !== FILE_STATUS.loaded && status !== STATUS.pending
  const displayFormatsAccepted = fileStatus !== FILE_STATUS.loaded
  const { status: loadingState } = useSelector(
    (state: IStore) => state.loadingReducer
  )
  const showDelete =
    fileStatus !== FILE_STATUS.loaded && loadingState !== STATUS.pending
  const canRetryUpload = !isMultifile && canRetry && status !== STATUS.pending

  return (
    <div className="mb3 mb6md">
      <div className="row">
        <UploadErrorAlert fileAlert={fileAlert} />
        <p className="mb05 textSecondaryDark col12">{title}</p>
        {displayFormatsAccepted && (
          <div className="colSm6 fontStyleIt fontSizeXs textPrimaryDark mb3 mb15md">
            {displayTooltip && <DocumentTooltipBuilder type={tooltip} />}
            {displayFormatsAccepted && (
              <p>
                Formats acceptés : JPG, PNG, PDF Taille max :{' '}
                {isMultifile ? 10 : 20} Mo
              </p>
            )}
          </div>
        )}
        <div className="colSm6 dFlex justifyContentEnd alignItemsCenter">
          {file ? (
            <UploadPreview
              file={file}
              removeFile={removeFile}
              showDelete={showDelete || canRetryUpload}
              className={
                displayFormatsAccepted && showDelete
                  ? 'justifyContentMdEnd'
                  : 'justifyContentMdStart'
              }
            />
          ) : (
            <UploadButton
              updateFiles={updateFiles}
              index={index}
              updateFileErrors={updateFileErrors}
              isMultifile={isMultifile}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default UploadFile
